/* eslint-disable @typescript-eslint/no-unused-vars */
import cadex from '@cadexchanger/web-toolkit'
import { ModelNode } from './types'

export class TreeViewVisitor extends cadex.ModelData_SceneGraphElementVisitor {
  private _nodes: ModelNode[] = []
  private _lastInstance: cadex.ModelData_Instance | null
  private _lastAssembly: cadex.ModelData_Assembly | null
  private _level = 0

  constructor(private rootNode) {
    super()

    this._nodes = []
    this._lastInstance = null
    this._lastAssembly = rootNode
  }

  get nodes() {
    return this._nodes
  }

  private currentNode() {
    return this._nodes[this._nodes.length - 1]
  }

  visitPart(thePart: cadex.ModelData_Part) {
    const treeItem: ModelNode = {
      id: thePart.uuid,
      text:
        (this._lastInstance && this._lastInstance.name) ||
        thePart.name ||
        'unnamed part',
      type: 'part',
      parent: this._lastAssembly?.uuid,
      level: this._level + 1,
      // data: {
      //   sge: this._lastInstance || thePart
      // }
    }

    this._nodes.push(treeItem)

    return Promise.resolve()
  }
  /**
   * @override
   * @param {!cadex.ModelData_Instance} theInstance
   */
  visitInstanceEnter(theInstance: cadex.ModelData_Instance) {
    this._lastInstance = theInstance
    return true
  }
  /**
   * @override
   * @param {!cadex.ModelData_Instance} theInstance
   */
  visitInstanceLeave(theInstance: cadex.ModelData_Instance) {
    this._lastInstance = null
    return Promise.resolve()
  }
  /**
   * @override
   * @param {!cadex.ModelData_Assembly} theAssembly
   */
  visitAssemblyEnter(theAssembly: cadex.ModelData_Assembly) {
    const treeItem: ModelNode = {
      id: theAssembly.uuid,
      text:
        (this._lastInstance && this._lastInstance.name) ||
        theAssembly.name ||
        'unnamed assembly',
      type: 'assembly',
      parent: this._lastAssembly?.uuid || this.rootNode?.uuid,
      level: this._level++,
    }

    this._lastAssembly = theAssembly

    this._nodes.push(treeItem)

    return true
  }
  /**
   * @override
   * @param {!cadex.ModelData_Assembly} theAssembly
   */
  visitAssemblyLeave(theAssembly: cadex.ModelData_Assembly) {
    this._lastAssembly = null
    this._level--

    return Promise.resolve()
  }
}
